import React, { useEffect, useState } from 'react'
import AreaChartDiv from '../../../../../components/Rechart/AreaChart'
import http from '../../../../../config/BaseUrl';
function AreaComponent() {

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState("");

  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`dashboard-graph/data-capture`).then(res => {
        if (res.data) {
          setData(res.data.data)
          setIsLoading(false)
        }
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {

    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }

  useEffect(() => {
    fetchGraphData()
  }, [])

  // const data = [
  //   { name: 'M 1', share: 100, pv: 2400, amt: 2400 },
  //   { name: 'M 2', share: 250, pv: 2400, amt: 2400 },
  //   { name: 'M 3', share: 150, pv: 2400, amt: 2400 },
  //   { name: 'M 4', share: 300, pv: 2400, amt: 2400 },
  //   { name: 'M 5', share: 300, pv: 2400, amt: 2400 },
  //   { name: 'M 6', share: 800, pv: 2400, amt: 2400 },
  //   { name: 'M 7', share: 1800, pv: 2400, amt: 2400 },
  //   { name: 'M 8', share: 1300, pv: 2400, amt: 2400 },
  //   { name: 'M 9', share: 300, pv: 2400, amt: 2400 },
  //   { name: 'M 10', share: 500, pv: 2400, amt: 2400 },
  //   { name: 'M 11', share: 1600, pv: 2400, amt: 2400 },
  //   { name: 'M 12', share: 200, pv: 2400, amt: 2400 }
  // ]


  return (
    <div className="area-chart">
      <h5 className="text-center mb-0">Data Capture Trends</h5>
      <AreaChartDiv loading={isLoading} dataSet={data} dataKey={'name'} dataValue={'leads'} />
    </div>
  )
}

export default AreaComponent
